import * as actionTypes from './actionTypes';
import { dniService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';
import { sendDataPayment} from '@app/src/views/StepPayment/formPayment';


const fetchDniRequest = () => ({
  type: actionTypes.FETCH_DNI_REQUEST
});

const fetchDniFailure = () => ({
  type: actionTypes.FETCH_DNI_FAILURE
});

export const fetchDniSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.FETCH_DNI_SUCCESS,
  data
});

const createDniRequest = () => ({
  type: actionTypes.CREATE_DNI_REQUEST
});

const createDniFailure = () => ({
  type: actionTypes.CREATE_DNI_FAILURE
});

export const createDniSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.CREATE_DNI_SUCCESS,
  data
});

const updateDniRequest = () => ({
  type: actionTypes.UPDATE_DNI_REQUEST
});

const updateDniFailure = () => ({
  type: actionTypes.UPDATE_DNI_FAILURE
});

export const updateDniSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.UPDATE_DNI_SUCCESS,
  data
});

export const clearDniData = () => ({
  type: actionTypes.CLEAR_DNI_DATA
});

export const setDisabledDniInputs = (isDisabled: boolean) => ({
  type: actionTypes.SET_DISABLED_DNI_INPUTS,
  isDisabled
})

export const fetchDni = (documentNumber: string) => {
  return async dispatch => {
    dispatch(fetchDniRequest());
    try {
      const data = await dniService.get(documentNumber);
      dispatch(fetchDniSuccess(data));
    } catch(error) {
      dispatch(actionsModalError.openModalError());
      dispatch(fetchDniFailure());
    }
  }
}

export const createDniData = (json, categoryId, printDetailId, price) => {
  return async dispatch => {
    dispatch(createDniRequest());
    try {
      const data = await dniService.post(json);
      dispatch(createDniSuccess(data));
      dispatch(sendDataPayment({
        customer: data.id,
        printDetail: printDetailId,
        category: categoryId
      }, price));
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(createDniFailure());
    }
  }
}

export const updateDniData = (json, documentNumber: string, categoryId, printDetailId, price) => {
  return async dispatch => {
    dispatch(updateDniRequest());
    try {
      const data = await dniService.put(json, documentNumber);
      dispatch(updateDniSuccess(data));
      dispatch(sendDataPayment({
        customer: data.id,
        printDetail: printDetailId,
        category: categoryId
      }, price));
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(updateDniFailure());
    }
  }
}
